(function () {
  var config = window.PauseIt || { routes: {} };
  if (config.cartCount == null) {
    var countNode = document.querySelector("[data-cart-count]");
    config.cartCount = countNode ? parseInt(countNode.textContent, 10) || 0 : 0;
  }
  var header = document.querySelector(".shopify-section-group-header-group") || document.getElementById("SiteHeader");

  function setOffset() {
    if (!header) return;
    document.documentElement.style.setProperty("--header-offset", header.offsetHeight + "px");
  }

  if (header && "ResizeObserver" in window) {
    new ResizeObserver(setOffset).observe(header);
  }
  setOffset();

  var sentinel = document.querySelector("[data-header-sentinel]");
  if (header && sentinel && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var stuck = !entries[0].isIntersecting;
        if (header.classList.contains("is-stuck") === stuck) return;
        header.classList.toggle("is-stuck", stuck);
        setOffset();
      },
      { rootMargin: "0px 0px 0px 0px", threshold: 0 }
    );
    observer.observe(sentinel);
  } else if (header) {
    header.classList.add("is-stuck");
  }

  function openDialog(id) {
    var dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== "function") return;
    if (!dialog.open) {
      dialog.showModal();
      return;
    }
    if (id === "CartDrawer") {
      dialog.classList.remove("is-reopen");
      void dialog.offsetWidth;
      dialog.classList.add("is-reopen");
    }
  }

  function closeDialog(dialog) {
    if (dialog && dialog.open) dialog.close();
  }

  document.addEventListener("click", function (event) {
    var openMenu = event.target.closest("[data-open-menu]");
    var openSearch = event.target.closest("[data-open-search]");
    var openCart = event.target.closest("[data-open-cart]");
    var openFilters = event.target.closest("[data-open-filters]");
    var closer = event.target.closest("[data-close-dialog]");

    if (openMenu) openDialog("MenuDialog");
    if (event.target.closest("[data-open-review]")) openDialog("ReviewDialog");
    var sortToggle = event.target.closest("[data-sort-toggle]");
    var sortLink = event.target.closest(".sort__menu a");
    if (sortLink && (sortLink.getAttribute("href") === "#" || sortLink.getAttribute("href") === "")) {
      event.preventDefault();
      var grid = document.querySelector(".collection-results .product-grid");
      if (grid) {
        if (!grid.dataset.original) {
          Array.prototype.forEach.call(grid.children, function (card, index) {
            card.dataset.order = String(index);
          });
          grid.dataset.original = "1";
        }
        var label = sortLink.textContent.trim().toLowerCase();
        var cards = Array.prototype.slice.call(grid.children);
        function priceOf(card) {
          var node = card.querySelector(".sale") || card.querySelector(".price");
          return Number((node ? node.textContent : "").replace(/[^0-9]/g, "")) || 0;
        }
        cards.sort(function (a, b) {
          if (label.indexOf("low") !== -1) return priceOf(a) - priceOf(b);
          if (label.indexOf("high") !== -1) return priceOf(b) - priceOf(a);
          return Number(a.dataset.order) - Number(b.dataset.order);
        });
        cards.forEach(function (card) { grid.appendChild(card); });
      }
      sortLink.parentElement.querySelectorAll("a").forEach(function (link) {
        if (link === sortLink) link.setAttribute("aria-current", "true");
        else link.removeAttribute("aria-current");
      });
      sortLink.parentElement.hidden = true;
      var toggle = sortLink.closest(".sort").querySelector("[data-sort-toggle]");
      if (toggle) {
        var sortLabel = toggle.querySelector("[data-sort-label]");
        if (sortLabel) sortLabel.textContent = sortLink.textContent.trim();
        toggle.setAttribute("aria-expanded", "false");
      }
    }
    if (sortToggle) {
      var menu = sortToggle.parentElement.querySelector(".sort__menu");
      if (menu) {
        var open = menu.hasAttribute("hidden");
        menu.toggleAttribute("hidden", !open);
        sortToggle.setAttribute("aria-expanded", open ? "true" : "false");
      }
    } else if (!event.target.closest(".sort")) {
      document.querySelectorAll(".sort__menu").forEach(function (menu) {
        menu.hidden = true;
      });
    }
    var photo = event.target.closest("[data-lightbox]");
    if (photo) {
      var box = document.getElementById("ReviewLightbox");
      var image = box && box.querySelector("[data-lightbox-image]");
      if (box && image) {
        image.src = photo.getAttribute("data-lightbox");
        openDialog("ReviewLightbox");
      }
    }
    if (openSearch) {
      openDialog("SearchDialog");
      var input = document.querySelector("#SearchDialog input[type='search']");
      if (input) window.setTimeout(function () { input.focus(); }, 40);
    }
    if (openCart) openDialog("CartDrawer");
    if (openFilters) {
      var facets = document.getElementById("Facets");
      if (facets) {
        facets.classList.add("is-open");
        document.body.style.overflow = "hidden";
        var closeBtn = facets.querySelector("[data-close-filters]");
        if (closeBtn) closeBtn.focus();
      }
    }
    if (event.target.tagName === "DIALOG" && event.target.open) closeDialog(event.target);
    if (closer) {
      var dialog = closer.closest("dialog");
      if (dialog) closeDialog(dialog);
      var facetsBox = document.getElementById("Facets");
      if (closer.hasAttribute("data-close-filters") && facetsBox) {
        facetsBox.classList.remove("is-open");
        document.body.style.overflow = "";
      }
    }
  });

  var reviewDialog = document.getElementById("ReviewDialog");
  if (reviewDialog && new URLSearchParams(window.location.search).get("contact_posted") === "true") {
    openDialog("ReviewDialog");
  }
  var reviewForm = reviewDialog && reviewDialog.querySelector("form");

  function setReviewStars(value) {
    if (!reviewDialog) return;
    var rating = Math.max(1, Math.min(5, Number(value) || 5));
    var input = reviewDialog.querySelector("[data-star-value]");
    var buttons = reviewDialog.querySelectorAll("[data-star-picker] [data-star]");
    if (input) input.value = String(rating);
    buttons.forEach(function (button) {
      var star = Number(button.getAttribute("data-star")) || 0;
      var active = star <= rating;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-checked", star === rating ? "true" : "false");
    });
  }

  var reviewPhotoFiles = [];
  var REVIEW_PHOTO_MAX = 3;
  var REVIEW_PHOTO_MAX_BYTES = 500 * 1024;
  var REVIEW_PHOTO_MAX_LABEL = "500KB";

  function getReviewUploadEls() {
    if (!reviewDialog) return null;
    var wrap = reviewDialog.querySelector("[data-review-upload]");
    if (!wrap) return null;
    var maxBytes = Number(wrap.getAttribute("data-max-bytes"));
    return {
      wrap: wrap,
      fileInput: wrap.querySelector("[data-review-photo]"),
      ui: wrap.querySelector("[data-review-upload-ui]"),
      list: wrap.querySelector("[data-review-upload-list]"),
      title: wrap.querySelector("[data-review-upload-title]"),
      hint: wrap.querySelector("[data-review-upload-hint]"),
      max: Math.max(1, Number(wrap.getAttribute("data-max-photos")) || REVIEW_PHOTO_MAX),
      maxBytes: maxBytes > 0 ? maxBytes : REVIEW_PHOTO_MAX_BYTES,
      maxLabel: wrap.getAttribute("data-max-label") || REVIEW_PHOTO_MAX_LABEL
    };
  }

  function syncReviewPhotoInput(els) {
    if (!els || !els.fileInput || typeof DataTransfer === "undefined") return;
    var transfer = new DataTransfer();
    reviewPhotoFiles.forEach(function (file) {
      transfer.items.add(file);
    });
    els.fileInput.files = transfer.files;
  }

  function renderReviewPhotos() {
    var els = getReviewUploadEls();
    if (!els || !els.list || !els.ui) return;
    var max = els.max;
    els.list.innerHTML = "";
    reviewPhotoFiles.forEach(function (file, index) {
      var item = document.createElement("li");
      item.className = "review-upload__item";
      var img = document.createElement("img");
      img.alt = file.name || "Review photo " + (index + 1);
      var url = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(url);
      };
      img.src = url;
      var clear = document.createElement("button");
      clear.type = "button";
      clear.className = "review-upload__clear";
      clear.setAttribute("data-review-upload-clear", String(index));
      clear.setAttribute("aria-label", "Remove image " + (index + 1));
      clear.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
      item.appendChild(img);
      item.appendChild(clear);
      els.list.appendChild(item);
    });
    els.list.hidden = reviewPhotoFiles.length === 0;
    els.ui.hidden = reviewPhotoFiles.length >= max;
    els.wrap.classList.toggle("is-filled", reviewPhotoFiles.length > 0);
    if (els.title) {
      els.title.textContent = reviewPhotoFiles.length ? "Add more images" : "Upload images";
    }
    if (els.hint) {
      var left = max - reviewPhotoFiles.length;
      var sizeLabel = els.maxLabel || REVIEW_PHOTO_MAX_LABEL;
      els.hint.textContent =
        reviewPhotoFiles.length === 0
          ? "JPG or PNG, up to " + max + " · " + sizeLabel + " each"
          : left + " more · " + sizeLabel + " each";
    }
    syncReviewPhotoInput(els);
  }

  function clearReviewPhotos() {
    reviewPhotoFiles = [];
    var els = getReviewUploadEls();
    if (els && els.fileInput) els.fileInput.value = "";
    renderReviewPhotos();
  }

  function addReviewPhotos(fileList) {
    var els = getReviewUploadEls();
    var max = els ? els.max : REVIEW_PHOTO_MAX;
    var maxBytes = els ? els.maxBytes : REVIEW_PHOTO_MAX_BYTES;
    var sizeLabel = els ? els.maxLabel : REVIEW_PHOTO_MAX_LABEL;
    var incoming = Array.prototype.slice.call(fileList || []);
    var rejectedSize = false;
    var rejectedType = false;
    incoming.forEach(function (file) {
      if (reviewPhotoFiles.length >= max) return;
      if (!file || !file.type || file.type.indexOf("image/") !== 0) {
        rejectedType = true;
        return;
      }
      if (file.size > maxBytes) {
        rejectedSize = true;
        return;
      }
      var duplicate = reviewPhotoFiles.some(function (existing) {
        return existing.name === file.name && existing.size === file.size && existing.lastModified === file.lastModified;
      });
      if (duplicate) return;
      reviewPhotoFiles.push(file);
    });
    renderReviewPhotos();
    if (rejectedSize) {
      showToast("Each image must be " + sizeLabel + " or less.");
    } else if (rejectedType) {
      showToast("Use JPG or PNG images only.");
    }
  }

  var reviewBody = reviewDialog && reviewDialog.querySelector("[data-review-body]");
  var reviewCountEl = reviewDialog && reviewDialog.querySelector("[data-review-count]");
  function syncReviewBodyCount() {
    if (!reviewBody || !reviewCountEl) return;
    reviewCountEl.textContent = String(reviewBody.value.length);
  }
  if (reviewBody) {
    reviewBody.addEventListener("input", syncReviewBodyCount);
    syncReviewBodyCount();
  }

  if (reviewDialog) {
    reviewDialog.addEventListener("click", function (event) {
      var starBtn = event.target.closest("[data-star-picker] [data-star]");
      if (starBtn) {
        setReviewStars(starBtn.getAttribute("data-star"));
        return;
      }
      var clearBtn = event.target.closest("[data-review-upload-clear]");
      if (clearBtn) {
        event.preventDefault();
        event.stopPropagation();
        var index = Number(clearBtn.getAttribute("data-review-upload-clear"));
        if (!Number.isNaN(index)) {
          reviewPhotoFiles.splice(index, 1);
          renderReviewPhotos();
        }
      }
    });

    var photoInput = reviewDialog.querySelector("[data-review-photo]");
    if (photoInput) {
      photoInput.addEventListener("change", function () {
        addReviewPhotos(photoInput.files);
      });
    }

    reviewDialog.addEventListener("close", function () {
      setReviewStars(5);
      clearReviewPhotos();
      if (reviewBody) reviewBody.value = "";
      syncReviewBodyCount();
    });

    setReviewStars(5);
    renderReviewPhotos();
  }

  if (reviewForm && !reviewForm.getAttribute("action")) {
    reviewForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var note = reviewForm.querySelector(".review-form__note");
      if (!note) {
        note = document.createElement("p");
        note.className = "review-form__note";
        var body = reviewForm.querySelector(".review-form__body");
        if (body) body.insertBefore(note, body.firstChild);
        else reviewForm.insertBefore(note, reviewForm.firstChild);
      }
      note.hidden = false;
      note.textContent = "Thank you. We received your review.";
      reviewForm.reset();
      setReviewStars(5);
      clearReviewPhotos();
      syncReviewBodyCount();
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var facets = document.getElementById("Facets");
    if (facets && facets.classList.contains("is-open")) {
      facets.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  });

  function showToast(message) {
    var toast = document.querySelector("[data-toast]");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "toast";
      toast.setAttribute("data-toast", "");
      toast.hidden = true;
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.hidden = false;
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(function () {
      toast.hidden = true;
    }, 3200);
  }

  function money(amount) {
    return "Rs. " + Math.round(amount).toLocaleString("en-US");
  }

  function syncPreviewCart() {
    var cards = document.querySelectorAll(".bag-card");
    var subtotal = 0;
    var count = 0;
    cards.forEach(function (card) {
      var unit = Number(card.getAttribute("data-unit")) || 0;
      var input = card.querySelector(".qty input");
      var qty = input ? Number(input.value) || 0 : 0;
      subtotal += unit * qty;
      count += qty;
      var line = card.querySelector(".bag-card__line");
      if (line && unit) line.textContent = money(unit * qty);
      var minus = card.querySelector('[data-qty-change="-1"]');
      if (minus) minus.disabled = qty <= 1;
    });
    var shipping = subtotal > 0 && subtotal < 2499 ? 250 : 0;
    var note = document.querySelector(".ship-note");
    if (note) {
      if (subtotal <= 0) {
        note.textContent = "Your cart is empty";
        note.classList.remove("is-unlocked");
      } else if (subtotal >= 2499) {
        note.textContent = "Free shipping unlocked";
        note.classList.add("is-unlocked");
      } else {
        note.textContent = "Add " + money(2499 - subtotal) + " more for free shipping";
        note.classList.remove("is-unlocked");
      }
    }
    var rows = document.querySelectorAll(".totals p");
    if (rows[0]) rows[0].lastElementChild.textContent = money(subtotal);
    if (rows[1]) rows[1].lastElementChild.textContent = shipping ? money(shipping) : "Free";
    if (rows[2]) rows[2].lastElementChild.textContent = money(subtotal + shipping);
    var title = document.querySelector(".cart-sheet__head h2");
    if (title) title.textContent = "Your cart (" + count + ")";
    setCount(count);
  }

  function updateBagQty(change) {
    var wrap = change.parentElement;
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var current = Number(input.value) || 1;
    var delta = Number(change.getAttribute("data-qty-change"));
    if (delta < 0 && current <= 1) return;
    var next = current + delta;
    input.value = String(next);
    var minus = wrap.querySelector('[data-qty-change="-1"]');
    if (minus) minus.disabled = next <= 1;
    var card = change.closest(".bag-card");
    var unit = card ? Number(card.getAttribute("data-unit")) : 0;
    var line = card && card.querySelector(".bag-card__line");
    if (line && unit) {
      line.textContent = money(unit * next);
    }
    syncPreviewCart();
  }

  function setCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = String(count);
      var wrap = el.closest("[data-cart-count-wrap]") || el;
      wrap.classList.toggle("has-items", count > 0);
    });
  }

  async function refreshCart() {
    var root = config.routes.root || "/";
    var response = await fetch(root + "?sections=cart-drawer");
    if (!response.ok) throw new Error("cart");
    var data = await response.json();
    var markup = data["cart-drawer"];
    if (!markup) throw new Error("section");
    var parsed = new DOMParser().parseFromString(markup, "text/html");
    var next = parsed.querySelector("[data-cart-body]");
    var current = document.querySelector("[data-cart-body]");
    if (next && current) current.innerHTML = next.innerHTML;
    var cart = await fetch((config.routes.cart || "/cart") + ".js", {
      headers: { Accept: "application/json" }
    }).then(function (res) { return res.json(); });
    setCount(cart.item_count || 0);
  }

  document.addEventListener("submit", async function (event) {
    var form = event.target.closest("form.product-form");
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector("[type='submit']");
    var original = button ? button.textContent : "";
    if (button) {
      button.disabled = true;
      button.textContent = "Adding…";
    }
    try {
      var response = await fetch((config.routes.cartAdd || "/cart/add") + ".js", {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" }
      });
      var payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || "Could not add this");
      await refreshCart();
      openDialog("CartDrawer");
    } catch (error) {
      showToast(error.message || "Could not add this");
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = original;
      }
    }
  });

  document.addEventListener("click", async function (event) {
    var quick = event.target.closest("[data-quick-add]");
    var change = event.target.closest("[data-qty-change]");
    var remove = event.target.closest("[data-remove-line]");
    if (!quick && !change && !remove) return;
    event.preventDefault();

    try {
      if (quick) {
        var body = new FormData();
        body.append("id", quick.getAttribute("data-quick-add"));
        body.append("quantity", "1");
        var added = await fetch((config.routes.cartAdd || "/cart/add") + ".js", {
          method: "POST",
          body: body,
          headers: { Accept: "application/json" }
        });
        var addedPayload = await added.json();
        if (!added.ok) throw new Error(addedPayload.description || "Could not add this");
        await refreshCart();
        openDialog("CartDrawer");
        return;
      }

      var key = (change || remove).getAttribute("data-line-key");
      if (!key || !config.routes.cartChange) {
        if (change) updateBagQty(change);
        if (remove) {
          var gone = remove.closest(".bag-card");
          if (gone) gone.remove();
          syncPreviewCart();
        }
        return;
      }

      var nextQty = 0;
      if (change) {
        var input = change.parentElement.querySelector("input");
        var current = input ? Number(input.value) : 1;
        var delta = Number(change.getAttribute("data-qty-change"));
        if (delta < 0 && current <= 1) return;
        nextQty = current + delta;
      }
      var changed = await fetch((config.routes.cartChange || "/cart/change") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: nextQty })
      });
      if (!changed.ok) throw new Error("Could not update the bag");
      await refreshCart();
    } catch (error) {
      showToast(error.message || "Something went wrong");
    }
  });

  function initProductGallery(gallery) {
    if (!gallery || gallery.__pauseGallery) return;
    gallery.__pauseGallery = true;
    var stage = gallery.querySelector("[data-gallery-stage]");
    var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-slide]"));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-thumb]"));
    if (!stage || slides.length === 0) return;

    function currentIndex() {
      var width = stage.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / width)));
    }

    function setActive(index) {
      var next = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (node, i) {
        node.classList.toggle("is-active", i === next);
      });
      thumbs.forEach(function (button, i) {
        if (i === next) button.setAttribute("aria-current", "true");
        else button.removeAttribute("aria-current");
      });
      return next;
    }

    function goTo(index, smooth) {
      var next = setActive((index + slides.length) % slides.length);
      var slide = slides[next];
      if (!slide) return;
      stage.scrollTo({ left: slide.offsetLeft, behavior: smooth === false ? "auto" : "smooth" });
    }

    gallery.addEventListener("click", function (event) {
      var thumb = event.target.closest("[data-thumb]");
      if (thumb) {
        var id = thumb.getAttribute("data-thumb");
        var index = slides.findIndex(function (slide) {
          return slide.getAttribute("data-media-id") === id;
        });
        if (index >= 0) goTo(index);
        return;
      }
      if (event.target.closest("[data-gallery-prev]")) {
        goTo(currentIndex() - 1);
        return;
      }
      if (event.target.closest("[data-gallery-next]")) {
        goTo(currentIndex() + 1);
      }
    });

    var scrollTimer;
    stage.addEventListener(
      "scroll",
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          setActive(currentIndex());
        }, 60);
      },
      { passive: true }
    );
  }

  document.querySelectorAll("[data-gallery]").forEach(initProductGallery);

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-qty]");
    if (!button) return;
    var wrap = button.closest(".qty");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var value = Number(input.value || 1) + Number(button.getAttribute("data-qty"));
    var min = Number(input.min || 1);
    var max = input.max ? Number(input.max) : Infinity;
    input.value = String(Math.min(max, Math.max(min, value)));
    var minus = wrap.querySelector('[data-qty="-1"]');
    if (minus) minus.disabled = Number(input.value) <= min;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  document.querySelectorAll(".qty").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    var minus = wrap.querySelector('[data-qty="-1"]');
    if (input && minus) minus.disabled = Number(input.value || 1) <= Number(input.min || 1);
  });

  document.addEventListener("click", function (event) {
    var add = event.target.closest("[data-add-button]");
    if (!add || add.disabled) return;
    var form =
      add.closest("form") ||
      (add.getAttribute("form") ? document.getElementById(add.getAttribute("form")) : null);
    // Live Shopify product forms submit via the form handler below.
    if (form && form.classList.contains("product-form") && form.getAttribute("action")) return;
    event.preventDefault();
    var qtyInput = form && form.querySelector(".qty input");
    var addQty = qtyInput ? Number(qtyInput.value || 1) : 1;
    var card = document.querySelector(".bag-card");
    if (card) {
      var lineInput = card.querySelector(".qty input");
      if (lineInput) lineInput.value = String((Number(lineInput.value) || 0) + addQty);
    }
    syncPreviewCart();
    openDialog("CartDrawer");
  });

  document.addEventListener("click", function (event) {
    var checkout = event.target.closest(".cart-sheet__foot .btn");
    if (!checkout) return;
    var form = checkout.closest("form");
    if (form && form.getAttribute("action")) return;
    event.preventDefault();
    showToast("Checkout opens on the Shopify store.");
  });

  var productRoot = document.querySelector("[data-product]");
  if (productRoot) {
    var variantsNode = productRoot.querySelector("[data-variants]");
    var variants = [];
    try {
      variants = JSON.parse(variantsNode ? variantsNode.textContent : "[]");
    } catch (error) {
      variants = [];
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        productRoot.querySelectorAll("[data-option]:checked"),
        function (input) { return input.value; }
      );
    }

    function findVariant() {
      var options = selectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function renderVariant(variant) {
      if (!variant) return;
      var idInput = productRoot.querySelector("[name='id']");
      if (idInput) idInput.value = variant.id;
      document.querySelectorAll("[data-product-price]").forEach(function (node) {
        node.innerHTML = variant.price_html;
      });
      var button = productRoot.querySelector("[data-add-button]");
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.getAttribute("data-label") : button.getAttribute("data-sold");
      }
      var sticky = document.querySelector("[data-sticky-add]");
      if (sticky) {
        sticky.disabled = !variant.available;
        sticky.textContent = variant.available
          ? sticky.getAttribute("data-label")
          : sticky.getAttribute("data-sold");
      }
      if (variant.media_id) {
        var thumb = productRoot.querySelector('[data-thumb="' + variant.media_id + '"]');
        if (thumb) thumb.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }

    productRoot.addEventListener("change", function (event) {
      if (!event.target.matches("[data-option]")) return;
      renderVariant(findVariant());
    });

    var buyButton = productRoot.querySelector(".buy-row [data-add-button], .product-form [data-add-button]");
    var stickyBar = document.querySelector("[data-sticky-atc]");
    if (buyButton && stickyBar && "IntersectionObserver" in window) {
      var stickyMq = window.matchMedia("(max-width: 1023px)");
      var stickyObserver = new IntersectionObserver(function (entries) {
        if (!stickyMq.matches) {
          stickyBar.classList.remove("is-visible");
          return;
        }
        stickyBar.classList.toggle("is-visible", !entries[0].isIntersecting);
      }, { threshold: 0, rootMargin: "0px 0px 0px 0px" });
      stickyObserver.observe(buyButton);
      stickyMq.addEventListener("change", function () {
        if (!stickyMq.matches) stickyBar.classList.remove("is-visible");
      });
    }

  }

  document.querySelectorAll("product-recommendations").forEach(function (element) {
    var url = element.getAttribute("data-url");
    if (!url) return;
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, "text/html");
        var next = parsed.querySelector("product-recommendations");
        if (next && next.innerHTML.trim()) element.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  });

  document.querySelectorAll("[data-address-country]").forEach(function (country) {
    var form = country.closest("form");
    var province = form && form.querySelector("[data-address-province]");
    var wrap = form && form.querySelector("[data-province-wrap]");
    if (!province || !window.Shopify || !Shopify.CountryProvinceSelector) return;
    new Shopify.CountryProvinceSelector(country.id, province.id, {
      hideElement: wrap ? wrap.id : undefined
    });
  });

  (function initSearchDialog() {
    var dialog = document.getElementById("SearchDialog");
    if (!dialog) return;
    var input = dialog.querySelector("[data-search-input]");
    var results = dialog.querySelector("[data-search-results]");
    if (!input || !results) return;

    var searchTimer = null;
    var suggestedHtml = results.innerHTML;

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function productRow(item) {
      return (
        '<a class="search-result" href="' +
        escapeHtml(item.url) +
        '">' +
        (item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="56" height="56" loading="lazy">'
          : '<span class="search-result__media" aria-hidden="true"></span>') +
        '<span><span class="search-result__title">' +
        escapeHtml(item.title) +
        '</span><span class="search-result__price">' +
        escapeHtml(item.price || "") +
        "</span></span></a>"
      );
    }

    function renderProducts(items, label, query) {
      if (!items.length) {
        results.innerHTML = '<p class="search-empty">No products match “' + escapeHtml(query) + '”.</p>';
        return;
      }
      results.innerHTML =
        '<p class="search-results__label">' +
        escapeHtml(label) +
        "</p><div data-search-list>" +
        items.map(productRow).join("") +
        "</div>";
    }

    function showSuggested() {
      if (suggestedHtml && suggestedHtml.indexOf("search-result") !== -1) {
        results.innerHTML = suggestedHtml;
        return;
      }
      results.innerHTML = '<p class="search-empty">Start typing to find a product.</p>';
    }

    function fetchShopify(query) {
      var endpoint =
        (config.routes && config.routes.predictive_search_url) ||
        "/search/suggest.json";
      return fetch(
        endpoint +
          "?q=" +
          encodeURIComponent(query) +
          "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last"
      )
        .then(function (response) {
          if (!response.ok) throw new Error("search failed");
          return response.json();
        })
        .then(function (data) {
          var products =
            (data.resources && data.resources.results && data.resources.results.products) ||
            [];
          return products.map(function (product) {
            return {
              title: product.title,
              url: product.url,
              image: product.image || (product.featured_image && product.featured_image.url) || "",
              price: product.price
            };
          });
        });
    }

    function runSearch(query) {
      var q = (query || "").trim();
      if (!q) {
        showSuggested();
        return;
      }
      results.innerHTML = '<p class="search-empty">Searching…</p>';

      fetchShopify(q)
        .then(function (items) {
          renderProducts(items, "Products", q);
        })
        .catch(function () {
          results.innerHTML = '<p class="search-empty">Could not load results.</p>';
        });
    }

    showSuggested();

    input.addEventListener("input", function () {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () {
        runSearch(input.value);
      }, 120);
    });

    dialog.addEventListener("close", function () {
      input.value = "";
      showSuggested();
    });
  })();

  (function hydrateProductReviews() {
    var section = document.querySelector("[data-product-reviews][data-product-handle]");
    var catalog = window.PauseItReviews;
    if (!section || !catalog || !catalog.products) return;

    var handle = section.getAttribute("data-product-handle");
    var list = catalog.products[handle];
    if (!list || !list.length) return;

    var track = section.querySelector("[data-review-track]");
    if (!track) return;

    var summary = track.querySelector(".review--summary");
    var starPoly =
      '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>';
    function starSvg() {
      return (
        '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">' +
        starPoly +
        "</svg>"
      );
    }
    function summaryStar(kind) {
      if (kind === "full") {
        return '<span class="review-summary__star">' + starSvg() + "</span>";
      }
      if (kind === "half") {
        return (
          '<span class="review-summary__star review-summary__star--half">' +
          starSvg() +
          '<span class="review-summary__star-fill" aria-hidden="true">' +
          starSvg() +
          "</span></span>"
        );
      }
      return (
        '<span class="review-summary__star review-summary__star--empty">' +
        starSvg() +
        "</span>"
      );
    }
    function starsHtml(rating) {
      var html = "";
      for (var i = 1; i <= 5; i += 1) html += summaryStar(i <= rating ? "full" : "empty");
      return html;
    }
    function reviewCard(review) {
      return (
        '<figure class="review"><div class="stars" role="img" aria-label="' +
        review.rating +
        ' out of 5">' +
        starsHtml(review.rating) +
        "</div><blockquote>" +
        review.quote +
        '</blockquote><figcaption class="review__foot"><span class="review__who"><strong>' +
        review.name +
        "</strong><span>" +
        (review.city || "") +
        "</span></span></figcaption></figure>"
      );
    }

    var total = 0;
    list.forEach(function (review) {
      total += review.rating;
    });
    var avg = total / list.length;
    var display = Math.round(avg * 10) / 10;
    var floor = Math.floor(avg);
    var frac = avg - floor;

    if (summary) {
      var value = summary.querySelector(".review-summary__value");
      var count = summary.querySelector(".review-summary__count");
      var starWrap = summary.querySelector(".review-summary__stars");
      if (value) value.textContent = String(display);
      if (count) {
        count.textContent =
          "Based on " + list.length + " review" + (list.length === 1 ? "" : "s");
      }
      if (starWrap) {
        var bits = "";
        for (var s = 1; s <= 5; s += 1) {
          if (s <= floor) bits += summaryStar("full");
          else if (s === floor + 1 && frac >= 0.3) bits += summaryStar("half");
          else bits += summaryStar("empty");
        }
        starWrap.innerHTML = bits;
        starWrap.setAttribute("aria-label", display + " out of 5");
      }
    }

    Array.prototype.slice.call(track.querySelectorAll(".review:not(.review--summary)")).forEach(function (node) {
      node.remove();
    });
    var frag = document.createDocumentFragment();
    var temp = document.createElement("div");
    list.forEach(function (review) {
      temp.innerHTML = reviewCard(review);
      frag.appendChild(temp.firstChild);
    });
    track.appendChild(frag);
  })();

  (function initReviewCarousels() {
    var roots = document.querySelectorAll("[data-review-carousel]");
    if (!roots.length) return;

    function perPage() {
      /* Desktop: 3×2. Mobile/tablet: 2×2. Do not change desktop count. */
      if (window.matchMedia("(min-width: 768px)").matches) return 6;
      return 4;
    }

    roots.forEach(function (root) {
      var track = root.querySelector("[data-review-track]");
      var prev = root.querySelector("[data-review-prev]");
      var next = root.querySelector("[data-review-next]");
      if (!track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll(".review"));
      if (!cards.length) return;

      var pageIndex = 0;
      var pages = [];

      function build() {
        var isMobile = window.matchMedia("(max-width: 767px)").matches;
        var summary = null;
        var testimonials = [];
        cards.forEach(function (card) {
          if (card.classList.contains("review--summary")) summary = card;
          else testimonials.push(card);
        });

        var oldPin = root.querySelector("[data-review-summary-pin]");
        if (oldPin) oldPin.remove();

        pages = [];
        track.innerHTML = "";

        /* Mobile + summary: pin overall rating full-width above; carousel is testimonials only (2×2). */
        if (isMobile && summary) {
          var pin = document.createElement("div");
          pin.className = "review-carousel__summary";
          pin.setAttribute("data-review-summary-pin", "");
          pin.appendChild(summary);
          var viewport = root.querySelector(".review-carousel__viewport");
          if (viewport) root.insertBefore(pin, viewport);
          else root.insertBefore(pin, track);

          var mobileSize = 4;
          for (var m = 0; m < testimonials.length; m += mobileSize) {
            var mobilePage = document.createElement("div");
            mobilePage.className = "review-carousel__page";
            testimonials.slice(m, m + mobileSize).forEach(function (card) {
              mobilePage.appendChild(card);
            });
            track.appendChild(mobilePage);
            pages.push(mobilePage);
          }
        } else {
          var size = perPage();
          for (var i = 0; i < cards.length; i += size) {
            var page = document.createElement("div");
            page.className = "review-carousel__page";
            cards.slice(i, i + size).forEach(function (card) {
              page.appendChild(card);
            });
            track.appendChild(page);
            pages.push(page);
          }
        }

        pageIndex = Math.min(pageIndex, Math.max(0, pages.length - 1));
        go(pageIndex);
      }

      function go(index) {
        pageIndex = index;
        track.style.transform = "translate3d(-" + pageIndex * 100 + "%, 0, 0)";
        if (prev) prev.disabled = pageIndex <= 0;
        if (next) next.disabled = pageIndex >= pages.length - 1;
        var nav = root.querySelector(".review-carousel__nav");
        if (nav) nav.hidden = pages.length <= 1;
      }

      if (prev) {
        prev.addEventListener("click", function () {
          if (pageIndex > 0) go(pageIndex - 1);
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          if (pageIndex < pages.length - 1) go(pageIndex + 1);
        });
      }

      build();
      window.addEventListener("resize", function () {
        window.clearTimeout(root._reviewResize);
        root._reviewResize = window.setTimeout(build, 120);
      });
    });
  })();

  setCount(config.cartCount || 0);
})();
